var GalleryScript = (function($){

    var Init = function(){

        $(document).ready(function(){
            $('.gallery-container').each(function(){
                $(this).magnificPopup({
                  delegate: 'a',
                  type:'image',
                  gallery: {
                    enabled: true
                  },
                });
            });
            $('.js-image-pop').magnificPopup({
              type:'image'
            });
        });

    };

    // "public" methods
    return {
        Init : Init
    };

})(jQuery);
